/**
 * Sticky Add to Cart Bar - Mobile Only
 * Shows variant + price, syncs with main product form
 */

document.addEventListener('DOMContentLoaded', () => {
  const stickyATC = document.getElementById('StickyATC');
  
  if (!stickyATC) return;
  
  const mainForm = document.querySelector('form[action*="/cart/add"]');
  const mainATC = mainForm?.querySelector('button[type="submit"]');
  const mainQty = mainForm?.querySelector('input[name="quantity"]');
  const mainVariantInput = mainForm?.querySelector('input[name="id"], select[name="id"]');

  const stickyPrice = document.getElementById('StickyATCPrice');
  const stickyVariant = document.getElementById('StickyATCVariant');
  const stickyButton = stickyATC.querySelector('.sticky-atc__button');
  const qtyInput = stickyATC.querySelector('.sticky-atc__qty-input');
  const increaseBtn = stickyATC.querySelector('[data-action="increase"]');
  const decreaseBtn = stickyATC.querySelector('[data-action="decrease"]');

  if (!mainATC || !mainForm) return;

  // Get product data
  const productData = window.stickyATCProduct || window.Shopify?.product;

  /**
   * Format price in euros
   */
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + amount;
  }

  /**
   * Show/hide sticky bar based on main ATC visibility
   */
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        stickyATC.classList.remove('is-visible');
      } else {
        stickyATC.classList.add('is-visible');
      }
    },
    { threshold: 0, rootMargin: '0px' }
  );
  observer.observe(mainATC);

  /**
   * Quantity controls
   */
  if (increaseBtn) {
    increaseBtn.addEventListener('click', () => {
      qtyInput.value = Number(qtyInput.value) + 1;
    });
  }

  if (decreaseBtn) {
    decreaseBtn.addEventListener('click', () => {
      qtyInput.value = Math.max(1, Number(qtyInput.value) - 1);
    });
  }

  /**
   * Add to cart click
   */
  if (stickyButton) {
    stickyButton.addEventListener('click', () => {
      // Sync quantity to main form
      if (mainQty) {
        mainQty.value = qtyInput.value;
      }
      
      // Add loading state
      stickyButton.classList.add('is-loading');
      
      // Trigger main form submit
      mainATC.click();
      
      // Remove loading state after a delay
      setTimeout(() => {
        stickyButton.classList.remove('is-loading');
      }, 1500);
    });
  }

  /**
   * Update sticky bar with variant info
   */
  function updateVariantInfo(variant) {
    if (!variant) return;

    // Update variant title
    if (stickyVariant) {
      const title = variant.public_title || variant.title;
      // Don't show "Default Title" for products without variants
      stickyVariant.textContent = title === 'Default Title' ? '' : title;
    }

    // Update price
    if (stickyPrice) {
      stickyPrice.textContent = formatMoney(variant.price);
    }

    // Update sold out state
    if (stickyButton) {
      if (variant.available) {
        stickyButton.classList.remove('is-sold-out');
        stickyButton.innerHTML = `
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
          <span>Toevoegen</span>
        `;
      } else {
        stickyButton.classList.add('is-sold-out');
        stickyButton.innerHTML = '<span>Uitverkocht</span>';
      }
    }
  }

  /**
   * Listen for custom variant:change event (modern themes)
   */
  document.addEventListener('variant:change', (event) => {
    const variant = event.detail?.variant;
    if (variant) {
      updateVariantInfo(variant);
    }
  });

  /**
   * Listen for Shopify section API variant change
   */
  document.addEventListener('shopify:variant:change', (event) => {
    const variant = event.detail?.variant;
    if (variant) {
      updateVariantInfo(variant);
    }
  });

  /**
   * Fallback: Listen for form changes (input/select changes)
   */
  mainForm.addEventListener('change', () => {
    if (!productData?.variants) return;

    const selectedId = mainVariantInput?.value;
    if (!selectedId) return;

    const variant = productData.variants.find(v => String(v.id) === String(selectedId));
    if (variant) {
      updateVariantInfo(variant);
    }
  });

  /**
   * Also listen for clicks on variant buttons/swatches
   */
  const variantSelectors = document.querySelectorAll('[data-variant-option], .variant-picker__option, .swatch-input, .product-option input[type="radio"]');
  variantSelectors.forEach(selector => {
    selector.addEventListener('click', () => {
      // Small delay to allow the main form to update
      setTimeout(() => {
        if (!productData?.variants) return;
        
        const selectedId = mainVariantInput?.value;
        if (!selectedId) return;

        const variant = productData.variants.find(v => String(v.id) === String(selectedId));
        if (variant) {
          updateVariantInfo(variant);
        }
      }, 50);
    });
  });

  /**
   * MutationObserver for variant input changes (backup)
   */
  if (mainVariantInput) {
    const inputObserver = new MutationObserver(() => {
      if (!productData?.variants) return;
      
      const selectedId = mainVariantInput.value;
      const variant = productData.variants.find(v => String(v.id) === String(selectedId));
      if (variant) {
        updateVariantInfo(variant);
      }
    });

    inputObserver.observe(mainVariantInput, { 
      attributes: true, 
      attributeFilter: ['value'],
      childList: true 
    });
  }
});
